import { Component, Input } from '@angular/core';
import { BarcodeScannerService } from './barcode-scanner.service';

@Component({
  selector: 'monorepo-barcode-scanner',
  templateUrl: './barcode-scanner.component.html',
  styleUrls: ['./barcode-scanner.component.scss'],
})
export class BarcodeScannerComponent {
  @Input() title = 'Qr Code Scanning';
  @Input() hideSkip: boolean = false;
  constructor(private barcodeScannerService: BarcodeScannerService) {}

  closeScanner() {
    this.barcodeScannerService.scanHeaderAction('CLOSE');
  }

  skipScan() {
    this.barcodeScannerService.scanHeaderAction('SKIP');
  }
}
